module.exports = __webpack_public_path__ + "static/media/homeAcademyWeb.64c1c16b.png";